import { Injectable } from '@angular/core';
import { CanActivateChild, ActivatedRouteSnapshot, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { CourseService } from '@core/services/course/course.service';

@Injectable({
  providedIn: 'root',
})
export class CourseAccessGuard implements CanActivateChild {
  constructor(
    private readonly courseService: CourseService,
    private readonly router: Router
  ) {}

  canActivateChild(route: ActivatedRouteSnapshot): Observable<boolean> {
    const courseUuid = route.paramMap.get('uuid');

    if (!courseUuid) {
      this.router.navigate(['/']);
      return of(false);
    }

    return this.courseService.getCourse(courseUuid).pipe(
      map((course) => {
        if (!course.expired_at) return true;

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const expiryDate = new Date(course.expired_at);
        expiryDate.setHours(0, 0, 0, 0);

        const isExpired = today > expiryDate;

        if (isExpired) {
          this.router.navigate(['/']);
          return false;
        }

        return true;
      }),
      catchError(() => {
        this.router.navigate(['/']);
        return of(false);
      })
    );
  }
}
